export default __webpack_public_path__ + "static/Digital_IDA_Unbranded_Patient_Tearsheet_Final Upload-4623b906063a0ebe4017ad53f3276487.pdf";